import { useMissionBillContext } from "api/mission/mission-bills/MissionBillsProvider";
import "./Table.scss";
import Icon from "core/icon/Icon";
import colors from "../../assets/styles/mixins/colors.scss";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { QUERY_STATUS, SCOPES } from "constants/constants";
import LoaderV2 from "core/loader/LoaderV2";
import { useDashboardStatsContext } from "api/dashboard/dashboard-stats/DashboardStatsProvider";
import { getDefaulMessage } from "utils/tableContentHelper";

export const Table = ({
  entity,
  id,
  header,
  content,
  tableWidth,
  tableOverflow,
  userScope,
  caFaeSelectedYear,
  alternRowColor,
  isDashboard,
}) => {
  const { setSelectedDateObj } = useMissionBillContext();
  const { loadDataStatus } = useDashboardStatsContext();

  const renderToBillCells = (elm, key) => {
    if (
      loadDataStatus.billingStats === QUERY_STATUS.LOADING &&
      id === "dashboard-FAE-table"
    ) {
      return <LoaderV2 loaderSize="small-loader" />;
    }
    const numericVal = parseInt(elm[key]?.value);
    return elm[key]?.status === "to-bill" ? (
      <Link
        to={`/${userScope}/inputs/spreadsheet`}
        state={{
          isFromDashboardCaFae: true,
          month: elm[key]?.id,
          year: caFaeSelectedYear,
        }}
        onClick={() => {
          setSelectedDateObj({
            month: elm[key]?.id,
            year: caFaeSelectedYear,
          });
        }}
        style={{
          color: numericVal > 0 ? "red" : "inherit",
          fontSize: "18px",
          fontWeight: numericVal > 0 ? "700" : "normal",
          whiteSpace: !isDashboard ? "nowrap" : "inherit",
        }}
      >
        {elm[key]?.value || elm[key]?.display || elm[key]}
      </Link>
    ) : (
      renderCellContent(elm, key)
    );
  };

  const renderCellContent = (elm, key) => {
    if (
      loadDataStatus.billingStats === QUERY_STATUS.LOADING &&
      id === "dashboard-CA-table"
    ) {
      return <LoaderV2 loaderSize="small-loader" />;
    }

    if (isDashboard) {
      return (
        <div
          style={{
            color: elm[key]?.color,
            fontWeight: elm[key]?.fontWeight,
          }}
        >
          <span
            style={{
              fontWeight: elm[key]?.fontWeight,
            }}
          >
            {elm[key]?.value !== undefined ? elm[key]?.value : ""}
          </span>
          <span
            style={{
              fontWeight: elm[key]?.fontWeight,
            }}
          >
            {userScope !== SCOPES.PERSO ? elm[key]?.new_missions_per_month : ""}
          </span>
        </div>
      );
    } else {
      return <span>{elm[key]?.value || elm[key]?.display || elm[key]}</span>;
    }
  };

  const getCellBackground = (cell, key, isSelected) => {
    const backgroundColors = {
      2: colors?.lightGreen2,
      3: colors?.lightYellow,
      4: colors?.lightRed,
    };
    if (cell?.isDisabled) return "rgba(194, 191, 209, 0.2)";
    if (cell?.hasOriginalInOptions) {
      if (cell?.original === false) return colors?.lightRed;
      if (cell?.original === true) return colors?.lightGreen2;
      return "";
    }
    if (isSelected) return backgroundColors[key] || "";
    return "";
  };

  return (
    <div className="table-scroll-container">
      <table
        id={id}
        className="fo-table"
        style={{
          width: tableWidth || "100%",
          overflow: tableOverflow ? "hidden" : undefined,
        }}
      >
        <thead>
          <tr>
            {header?.map((elm) => (
              <th
                key={elm?.id || elm?.value || elm?.key || elm?.label?.key}
                style={{
                  width: elm.width,
                  paddingLeft: elm.paddingLeft,
                  minWidth: elm.minWidth,
                  maxWidth: elm.maxWidth,
                  display: elm?.display,
                  borderRight: elm?.borderRight,
                }}
                {...(elm.label?.value === "id" && {
                  style: { display: "none" },
                })}
              >
                <div className="column-title">
                  {elm?.icon && (
                    <Icon
                      color="gray-200"
                      icon={elm?.icon}
                      width={elm?.iconWidth}
                      height={elm?.iconHeight}
                      marginTop={elm?.marginTop}
                    />
                  )}
                  <span style={{ fontWeight: elm.fontWeight }}>
                    {" "}
                    {elm?.label?.value}
                  </span>
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className={alternRowColor ? "altern-row-color" : ""}>
          {content?.length === 0 ? (
            <tr>
              <td colSpan={Object.keys(header).length} className="empty-td">
                <span>
                  <FormattedMessage
                    id={getDefaulMessage(entity)?.id}
                    defaultMessage={getDefaulMessage(entity)?.defaultMessage}
                  />
                </span>
              </td>
            </tr>
          ) : (
            content?.length > 0 &&
            content?.map((elm, index) => (
              <tr key={elm?.id || index}>
                {Object.keys(elm).map((key, index) => {
                  if (key !== "status_for_color" && key !== "name_for_search") {
                    const isSelected = elm[key]?.isSelected;
                    const backgroundColor = getCellBackground(
                      elm[key],
                      key,
                      isSelected
                    );
                    // Check if this cell contains a radio button
                    const hasRadioButton = elm[key]?.isRadioCell;

                    const handleCellClick = () => {
                      if (hasRadioButton && !elm[key]?.isDisabled) {
                        // Find and click the radio input inside this cell
                        const cellElement = document.getElementById(
                          elm[key]?.id
                        );
                        if (cellElement) {
                          const radioInput = cellElement.querySelector(
                            'input[type="radio"]'
                          );
                          if (radioInput) {
                            radioInput.click();
                          }
                        }
                      }
                    };

                    return (
                      <td
                        key={elm[key]?.id || `${key}-${index}`}
                        id={elm[key]?.id}
                        style={{
                          display: key === "id" ? "none" : undefined,
                          background: backgroundColor || "",
                          cursor: hasRadioButton && !elm[key]?.isDisabled ? "pointer" : "default",
                        }}
                        onClick={handleCellClick}
                      >
                        {elm[key]?.status === "to-bill" &&
                          renderToBillCells(elm, key)}
                        {elm[key]?.status !== "to-bill" &&
                          renderCellContent(elm, key)}
                      </td>
                    );
                  } else {
                    return null;
                  }
                })}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

Table.propTypes = {
  entity: PropTypes.string,
  id: PropTypes.string,
  header: PropTypes.array.isRequired,
  content: PropTypes.array.isRequired,
  tableWidth: PropTypes.bool,
  tableOverflow: PropTypes.bool,
  userScope: PropTypes.string.isRequired,
  caFaeSelectedYear: PropTypes.number,
  alternRowColor: PropTypes.bool,
  isDashboard: PropTypes.bool,
  selectedColor: PropTypes.string,
};
